/* eslint no-unused-vars: 0 */
import { Canvas, TEvent, Group } from 'fabric';
import { FabricCanvasTool } from '../index';
import RectangleLabelObject from './Rectangle-label-object';
import { SketchProperties, Tool } from '../../../../types';

// eslint-disable-next-line import/prefer-default-export
export class RectangleLabel extends FabricCanvasTool {
    private width?: number;

    private color?: string;

    private isDown: boolean;

    private textString: string = '';

    private fill?: string;

    private maxFontSize: number = 12;

    private startX: number;

    private startY: number;

    private rectangleLabel: RectangleLabelObject | null;

    private objects: RectangleLabelObject[] = [];

    type(): Tool {
        return Tool.RECTANGLE;
    }

    constructor(canvas: Canvas) {
        super(canvas);
        this.startX = 0;
        this.startY = 0;
        this.isDown = false;
        this.rectangleLabel = null;
    }
  
    configureCanvas(props: SketchProperties) {
        this.canvas.isDrawingMode = false;
        this.canvas.selection = false;
        this.canvas.forEachObject(o => { o.selectable = false; o.evented = false; });
        this.width = props.lineWidth;
        this.color = props.lineColor;
        this.fill = props.fillColor;
        this.textString = props.text || '';
        this.maxFontSize = 12;
    }

    doMouseDown(o: TEvent) {
        this.isDown = true;
        const pointer = this.canvas.getPointer(o.e);
        this.startX = pointer.x;
        this.startY = pointer.y;

        this.rectangleLabel = new RectangleLabelObject(
            this.canvas,
            'New drawing',
            {
                left: this.startX,
                top: this.startY,
                originX: 'left',
                originY: 'top',
                width: pointer.x - this.startX,
                height: pointer.y - this.startY,
                stroke: this.color,
                strokeWidth: this.width,
                fill: this.fill,
                transparentCorners: false,
                selectable: false,
                evented: false,
                strokeUniform: true,
                noScaleCache: false,
                angle: 0,
            },
            {
                left: this.startX,
                top: this.startY - 12,
                originX: 'left',
                originY: 'top',
                // @ts-ignore
                width: pointer.x - this.startX - this.width,
                height: this.canvas.height / 3,
                fontSize: this.maxFontSize,
                noScaleCache: false,
                backgroundColor: this.color,
                transparentCorners: true,
                hasControls: false,
                angle: 0,
            },
        );

        if (this.objects && this.objects.length > 0) this.objects.push(this.rectangleLabel);
        else this.objects = [this.rectangleLabel];

        while (this.rectangleLabel.textObj.height > this.canvas.height / 3) {
            this.rectangleLabel.textObj.set({
                fontSize: this.rectangleLabel.textObj.fontSize - 1,
                top: this.startY - this.rectangleLabel.textObj.fontSize - 12,
            });
        }

        this.canvas.add(this.rectangleLabel.rectObj);
        this.canvas.add(this.rectangleLabel.textObj);
        this.canvas.renderAll();
    }

    doMouseMove(o: TEvent) {
        if (!this.isDown) return;
        const pointer = this.canvas.getPointer(o.e);
        if (this.rectangleLabel) {
            if (this.startX > pointer.x) {
                this.rectangleLabel.rectObj.set({ left: Math.abs(pointer.x) });
                this.rectangleLabel.textObj.set({ left: Math.abs(pointer.x) });
            }
            if (this.startY > pointer.y) {
                this.rectangleLabel.rectObj.set({ left: Math.abs(pointer.x) });
                this.rectangleLabel.textObj.set({ top: Math.abs(pointer.y) });
            }
            this.rectangleLabel.textObj.setCoords();
            this.rectangleLabel.rectObj.set({
                width: Math.abs(this.startX - pointer.x),
            });
            this.rectangleLabel.textObj.set({
                width: this.rectangleLabel.rectObj.getScaledWidth(),
            });
            this.rectangleLabel.rectObj.set({
                height: Math.abs(this.startY - pointer.y),
            });
            this.rectangleLabel.rectObj.setCoords();
        }
        this.canvas.renderAll();
    }

    doMouseUp(o:TEvent) {
        this.isDown = false;
        const group = new Group([this.rectangleLabel!.rectObj, this.rectangleLabel!.textObj]);
        this.canvas.remove(this.rectangleLabel!.rectObj);
        this.canvas.remove(this.rectangleLabel!.textObj);
        this.canvas.add(group);
        this.canvas.renderAll();
    }
}
